import React, { useEffect, useState } from "react";
import SEO from "../../components/SEO";
import { findEventBySlug } from "../../data/events";
import asset from "../../utils/assetUrl";

// Clave temporal que RegistrationForm deja antes de redirigir.
const CITY_KEY = 'pc_registro_ciudad';

const SITE = 'https://conferenciaparacanada.com';

// Fecha ICS en UTC basico: 20261006T220000Z
const toIcsDate = (iso) =>
    new Date(iso).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

// RFC 5545: en los valores de texto hay que escapar \ ; , y los saltos.
const escapeIcs = (text) =>
    String(text)
        .replace(/\\/g, '\\\\')
        .replace(/;/g, '\\;')
        .replace(/,/g, '\\,')
        .replace(/\r?\n/g, '\\n');

const buildIcs = (event) => {
    const lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Para Canada//Conferencia para Canada//ES',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:conferencia-${event.slug}-2026@conferenciaparacanada.com`,
        `DTSTAMP:${toIcsDate(new Date().toISOString())}`,
        `DTSTART:${toIcsDate(event.start)}`,
        `DTEND:${toIcsDate(event.end)}`,
        `SUMMARY:${escapeIcs(`Conferencia para Canadá en ${event.city}`)}`,
        `LOCATION:${escapeIcs(`${event.venue}, ${event.street}, ${event.city}`)}`,
        `DESCRIPTION:${escapeIcs(
            `Tu lugar está apartado. Lleva tu identificación oficial (INE o pasaporte). Más información en ${SITE}`
        )}`,
        'BEGIN:VALARM',
        'TRIGGER:-P1D',
        'ACTION:DISPLAY',
        'DESCRIPTION:Mañana es la Conferencia para Canadá',
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR'
    ];
    return lines.join('\r\n');
};

function Gracias() {
    // Se guarda en estado antes de borrarlo de sessionStorage, para que los
    // botones de abajo sigan funcionando durante toda la visita.
    const [ciudad, setCiudad] = useState(null);

    useEffect(() => {
        document.body.classList.add('thanks');
        return () => {
            document.body.classList.remove('thanks');
        };
    }, []);

    useEffect(() => {
        let slug = '';
        try {
            slug = window.sessionStorage.getItem(CITY_KEY) || '';
            // Se consume una sola vez: recargar /gracias no vuelve a contar
            // la conversión.
            window.sessionStorage.removeItem(CITY_KEY);
        } catch (e) {
            // sessionStorage bloqueado (modo privado): seguimos sin ciudad.
        }

        if (!slug) {
            return;
        }

        setCiudad(slug);

        if (typeof window.fbq === 'function') {
            window.fbq('track', 'CompleteRegistration', {
                content_name: 'Conferencia para Canada 2026',
                content_category: slug,
                status: true,
                currency: 'MXN',
                value: 0
            });
        }

        if (typeof window.gtag === 'function') {
            window.gtag('event', 'generate_lead', {
                event_category: 'registro',
                event_label: slug,
                value: 0
            });
        }
    }, []);

    const evento = ciudad ? findEventBySlug(ciudad) : null;

    const descargarCalendario = () => {
        if (!evento) return;
        const blob = new Blob([buildIcs(evento)], {
            type: 'text/calendar;charset=utf-8'
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `conferencia-para-canada-${evento.slug}.ics`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // Sin esto el blob queda retenido en memoria hasta recargar.
        URL.revokeObjectURL(url);
    };

    return (
        <>
            <SEO
                title="¡Gracias por tu registro!"
                description="Estamos emocionados de acompañarte en tu camino hacia Canadá"
                keywords="conferencia para canada, estudiar en canada, migrar a canada, residencia permanente"
                ogImage={`${SITE}/assets/images/og.jpg`}
                favicon={`${SITE}/assets/images/favicon-32x32.png`}
                appleFavicon={`${SITE}/assets/images/apple-touch-icon.png`}
                canonical={`${SITE}/gracias`}
                noindex
            />

            <div style={{ backgroundImage: `url(${asset('/assets/images/hero.jpg')})` }} className="hero nostatic">
                <div className="container">
                    <img className="mainLogo" src={asset("/assets/images/Para_Canada_Conferencia_Logo_White.svg")} alt="Conferencia para Canadá" />
                    <hr />
                    <h1>¡Tu registro ha sido exitoso!</h1>

                    {/* Dos columnas de la misma altura en escritorio: la
                        confirmacion y el aviso del pase pesan lo mismo, y en
                        vertical el segundo quedaba muy abajo. */}
                    <div className="thanks__cols">
                    <p className="lead">
                        ¡Gracias por registrarte en la Conferencia para Canadá! Te hemos enviado un correo
                        con la confirmación, que incluye el lugar exacto del evento, la fecha y la hora.
                        <br />
                        <strong>¡Estamos emocionados de acompañarte en tu camino hacia Canadá!</strong>
                    </p>

                    {/* El momento de mas atencion de todo el registro. Si alguien
                        solo lee una frase, que sea esta: sin el QR no puede
                        dejar sus datos a las instituciones el dia del evento. */}
                    <div className="thanks__pase">
                        <p className="thanks__pase-title">Revisa tu correo: ahí va tu pase</p>
                        <p className="thanks__pase-text">
                            Dentro encontrarás un <strong>código QR</strong> que es tu pase de acceso.
                            Guárdalo en el celular: el día de la Conferencia se lo muestras a las
                            instituciones que te interesen y ellas te enviarán su información directamente.
                        </p>
                        <p className="thanks__pase-note">
                            ¿No te llegó en unos minutos? Mira en spam o promociones antes de escribirnos.
                        </p>
                    </div>
                    </div>

                    {evento && (
                        <div className="thanks__event">
                            <p className="thanks__event-city">{evento.city}</p>
                            <p className="thanks__event-venue">{evento.venue}</p>
                            <p className="thanks__event-street">{evento.street}</p>
                        </div>
                    )}

                    {/* Una sola accion, la que reduce el no-show. */}
                    <div className="thanks__actions">
                        {evento && (
                            <button type="button" className="button" onClick={descargarCalendario}>
                                Agregar a mi calendario
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <footer className="footer nostatic" style={{ backgroundImage: `url(${asset('/assets/images/footer.jpg')})` }}>
                <div className="container">
                    <div className="row footer-contact">
                        <div className="col-12">
                            <h2 className="gradient-title">¿Dudas?</h2>
                            <p>
                                Si tienes alguna pregunta, no dudes en contactarnos a{" "}
                                <a style={{ display: 'block' }} target="_blank" rel="noreferrer" href="mailto:info@para-canada.com">
                                    info@para-canada.com
                                </a>
                            </p>
                        </div>
                    </div>
                    <div className="row footer-copy">
                        <div className="col-12">
                            <p>&copy; 2026. Todos los derechos reservados.</p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default Gracias;
